import { useState, useEffect } from "react";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { Grid, Typography, Button, CircularProgress } from "@mui/material";
import { protectedResources } from "../../authConfig";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import AddTaskIcon from "@mui/icons-material/AddTask";
import Tooltip from "@mui/material/Tooltip";
import { formatNumber, formatDate, getButton } from "../../Utils/utils";
import Alert from "@mui/material/Alert";
import { DataTabs } from "../LabTabs";
import { isTestEnv } from "../../globals";
import { NotesAccordion } from "../../components/Tasks";
import { AddTaskDialog } from "./addTaskDialog";

export const DelayedOrders = ({ Orders }) => {
  const [checkedItems, setCheckedItems] = useState({});
  const [error, setError] = useState(null);
  const [expandedPanel, setExpandedPanel] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedOrderNotes, setSelectedOrderNotes] = useState(null);
  const [DOrders, setDOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addTaskDialogOpen, setAddTaskDialogOpen] = useState(false);
  const [selectedOrderForTask, setSelectedOrderForTask] = useState(null);

  useEffect(() => {
    if (Orders && Orders.length > 0) {
      const initialOrders = Orders.map((row, index) => ({
        ...row,
        id: index,
        STATUSDATE: new Date(row["STATUSDATE"]),
        NEO_REQDATE: new Date(row["NEO_REQDATE"]),
        NEO_DUEDATE: new Date(row["NEO_DUEDATE"]),
      }));
      setDOrders(initialOrders);
    }
  }, [Orders]);

  const handleAddTaskToOrder = (orderRow) => {
    console.log("handleAddTaskToOrder", orderRow);
    setSelectedOrderForTask(orderRow);
    setAddTaskDialogOpen(true);
  };

  const handleTaskAdded = (newTask) => {
    console.log("Updated_Order handleTaskAdded");

    const updatedOrder = {
      ...selectedOrderForTask,
      GENCUSTNOTES_SUBFORM: [
        ...(selectedOrderForTask.GENCUSTNOTES_SUBFORM || []),
        newTask,
      ],
    };

    // Update the orders state
    setDOrders((prevOrders) => {
      const updatedOrders = prevOrders.map((order) => {
        if (order.ORDNAME === selectedOrderForTask.ORDNAME) {
          return updatedOrder;
        }
        return order;
      });
      return updatedOrders;
    });

    // Close the task dialog FIRST
    setAddTaskDialogOpen(false);

    // Then open the notes dialog
    setTimeout(() => {
      setSelectedOrderNotes(updatedOrder);
      setOpenPopup(true);
    }, 100); // Small delay to ensure the dialog closed properly
  };

  const handleOpenPopup = (order) => {
    setSelectedOrderNotes(order);
    setOpenPopup(true);
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedOrderNotes(null);
  };

  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };

  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  const handleCheckboxChange = (selectedIds) => {
    isTestEnv && console.log("handleCheckboxChange", selectedIds);
    const selectedOrdnames = selectedIds
      .map((id) => {
        const selectedRow = DOrders.find((order) => order.id === id);
        return selectedRow ? selectedRow.ORDNAME : null;
      })
      .filter((ordname) => ordname !== null);
    isTestEnv && console.log("selectedOrdnames", selectedOrdnames);
    setCheckedItems(selectedOrdnames);
  };

  const isCheckboxVisible = (params) => {
    return params.row.ORDSTATUSDES == "טיוטא פרומדי";
  };

  const handleSubmitReleaseObligo = async () => {
    isTestEnv && console.log("handleSubmitReleaseObligo");
    setLoading(true); // Start loading
    isTestEnv && console.log("checkedItems", checkedItems);
    try {
      const response = await execute(
        "POST",
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/financialData/obligoRelease`,
        { ordnames: checkedItems }
      );
      if (response) {
        // Remove the selected rows from DOrders
        const updatedOrders = DOrders.filter(
          (order) => !checkedItems.includes(order.ORDNAME)
        );
        setDOrders(updatedOrders);
        isTestEnv && console.log("updatedOrders", updatedOrders);
      }
    } catch (error) {
      isTestEnv && console.error("error", error);
      setError(
        <Alert severity="error" onClose={() => setError(null)}>
          אירעה תקלה, אנא נסו שנית מאוחר יותר
        </Alert>
      );
    } finally {
      setLoading(false);
    }
  };

  const dataGridColumns = [
    {
      field: "ORDNAME",
      headerName: "מספר הזמנה",
      cellClassName: "first-column",
    },
    { field: "CUSTNAME", headerName: "מספר לקוח" },
    { field: "CDES", headerName: "שם לקוח" },
    {
      field: "STATUSDATE",
      headerName: "תאריך עדכון סטטוס",
      type: "date",
    },
    {
      field: "NEO_DUEDATE",
      headerName: "תאריך אספקה להזמנה",
      type: "date",
    },
    {
      field: "NEO_REQDATE",
      headerName: "תאריך מבוקש לאספקה",
      type: "date",
    },
    { field: "ORDSTATUSDES", headerName: "סטטוס" },
    {
      field: "TOTPRICE",
      headerName: 'מחיר כולל מע"מ',
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "STATUSICON",
      headerName: "משימות להזמנה",
      renderCell: (params) => {
        const currentOrder =
          DOrders.find((order) => order.ORDNAME === params.row.ORDNAME) ||
          params.row;
        const hasTasks =
          Array.isArray(currentOrder.GENCUSTNOTES_SUBFORM) &&
          currentOrder.GENCUSTNOTES_SUBFORM.length > 0;
        const icon = hasTasks ? <LaunchIcon /> : <AddTaskIcon />;
        const tooltipText = hasTasks ? "הצג משימות" : "הוסף משימה";
        const handleClick = (event) => {
          event.stopPropagation(); // Prevent row click
          hasTasks
            ? handleOpenPopup(currentOrder)
            : handleAddTaskToOrder(currentOrder);
        };

        return (
          <Tooltip title={tooltipText}>
            <IconButton onClick={handleClick}>{icon}</IconButton>
          </Tooltip>
        );
      },
      sortable: false,
      filterable: false,
      minWidth: 100,
      flex: 0.1,
    },
  ];

  return (
    <Accordion
      expanded={expandedPanel}
      onChange={handleChange}
      disabled={Orders === null}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            הזמנות מעוכבות
          </span>
          <div style={{ marginRight: "40px" }}>
            <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
              סה"כ מספר הזמנות מעוכבות:{" "}
            </span>
            <span>{DOrders?.length}</span>
          </div>
        </div>
      </AccordionSummary>
      {DOrders?.length === 0 ? (
        <Alert severity="info">אין הזמנות מעוכבות ללקוח</Alert>
      ) : (
        <div>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  {dataGridColumns !== "undefined" && (
                    <DataTabs
                      data={DOrders}
                      columns={dataGridColumns}
                      TabKey={{ value: "BRANCHNAME", label: "סניף" }}
                      checkboxSelection={true}
                      handleCheckboxChange={handleCheckboxChange}
                      isCheckboxVisible={isCheckboxVisible}
                    />
                  )}
                </Typography>
                {loading ? (
                  <CircularProgress style={{ marginTop: 16 }} /> // Loading spinner
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitReleaseObligo}
                    style={{ marginTop: 16 }}
                  >
                    שחרר הזמנה
                  </Button>
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </div>
      )}
      <AddTaskDialog
        open={addTaskDialogOpen}
        onClose={() => setAddTaskDialogOpen(false)}
        ordname={selectedOrderForTask?.ORDNAME}
        doerName={selectedOrderForTask?.DOER_NAME} // Adjust based on your data structure
        onTaskAdded={handleTaskAdded}
        data={selectedOrderForTask?.GENCUSTNOTES_SUBFORM}
        setOrders={setDOrders}
      />
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth={false}
        PaperProps={{
          style: {
            width: "40vw",
            maxWidth: "50vw",
            maxHeight: "calc(100% - 50px)",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "left" }}>
          {" "}
          משימות להזמנה מספר {selectedOrderNotes?.ORDNAME}
        </DialogTitle>
        <DialogContent>
          <NotesAccordion
            data={selectedOrderNotes?.GENCUSTNOTES_SUBFORM}
            setOrders={setDOrders}
            ordname={selectedOrderNotes?.ORDNAME}
            doerName={
              selectedOrderNotes?.AGENTCODE
                ? selectedOrderNotes?.DOERNAME
                : null
            }
          />
        </DialogContent>
      </Dialog>
    </Accordion>
  );
};
